import { SVGProps, Ref, forwardRef } from 'react';

export const SendIosOutlinedSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.385 7.453C4.565 9.637 3.733 12.69 3.733 16s.832 6.363 2.652 8.547c1.756 2.107 4.692 3.72 9.615 3.72s7.859-1.613 9.615-3.72c1.82-2.184 2.652-5.237 2.652-8.547s-.832-6.363-2.652-8.547c-1.756-2.107-4.692-3.72-9.615-3.72s-7.859 1.613-9.615 3.72M16 1.333C5 1.333 1.333 8.667 1.333 16S5 30.667 16 30.667 30.667 23.333 30.667 16 27 1.333 16 1.333m1.2 11.56v10.44h-2.4v-10.44l-3.952 3.951-1.697-1.697L16 8.299l6.848 6.848-1.697 1.697z"
                fill="currentColor"
            />
        </g>
    </svg>
));
SendIosOutlinedSize32Glyph.displayName = 'SendIosOutlinedSize32Glyph';
